import { render, staticRenderFns } from "./DealDetail.vue?vue&type=template&id=490d1fd4&scoped=true&"
import script from "./DealDetail.vue?vue&type=script&lang=js&"
export * from "./DealDetail.vue?vue&type=script&lang=js&"
import style0 from "./DealDetail.vue?vue&type=style&index=0&id=490d1fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490d1fd4",
  null
  
)

export default component.exports